import { render, staticRenderFns } from "./OtherIncomes.vue?vue&type=template&id=45d1b9ba&scoped=true"
import script from "./OtherIncomes.vue?vue&type=script&lang=js"
export * from "./OtherIncomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1b9ba",
  null
  
)

export default component.exports